import { put, all } from "redux-saga/effects";

import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import messages from "rdx/modules/consultantDashboard/messages";
import { camelizeKeys } from "lib/helpers";

function* getMoreDashboardProjectActivity(action) {
  const endpoint = action.payload.isOrgDashboard ? "/enterprise_dashboard" : "/consultant_dashboard";
  const { success, data, error } = yield* makeRequest.get(`${endpoint}/project_activity`, {
    user_id: action.payload.userId,
    tab: action.payload.tab,
    page_scroll: action.payload.page,
    active_filters: action.payload.activeFilters,
    offset: 20 * (action.payload.page - 1),
    limit: 20,
    sort: action.payload.sort,
  });

  if (success && data) {
    yield all([put(actions.setMoreDashboardProjectActivity(camelizeKeys(data.body)))]);
  } else if (error) {
    return getErrorActions({
      error,
      message: messages.ERROR_GETTING_PROJECT_ACTIVITY,
    });
  }

  return null;
}

export default getMoreDashboardProjectActivity;
